import React, { useState } from 'react'
import EditProfileTab from './Components/EditProfileTab/EditProfileTab'
import PreferencesTab from './Components/PreferencesTab/PreferencesTab'
import SecurityTab from './Components/SecurityTab/SecurityTab'
import { Link } from 'react-router-dom'

const Setting = () => {
    const [activeTab, setActiveTab] = useState("edit-profile");
    return (
        <div>
            {/* x---------------------------------x Settings Option Section x---------------------------------x */}
            <div className="grid gap-3">
                <div className="w-full">
                    <div className="card bg-transparent h-full">
                        <div className="flex justify-between items-center card-header p-3">
                            <h3 className="text-dark sm:text-2xl text-lg font-semibold ">Settings Option</h3>
                            <Link to="/" className="text-dark text-end text-lg font-semibold block sm:hidden">See all</Link>
                        </div>

                        <div className="rounded-2xl mb-3 card-body w-full h-full">
                            <div className="p-4">
                                {/* x---------------------------------x Tab Navigation x---------------------------------x */}
                                <div className="border-b border-gray-200 text-dark">
                                    <nav className="flex gap-x-1 sm:flex-row flex-col" aria-label="Tabs" role="tablist">
                                        <button
                                            type="button"
                                            className={`font-semibold py-2 px-2 inline-flex items-center gap-x-2 border-b-[3px] border-transparent whitespace-nowrap hover:text-primary hover:border-primary focus:outline-none focus:text-primary ${activeTab === 'edit-profile' ? 'tab_active' : ''}`}
                                            onClick={() => setActiveTab('edit-profile')}
                                            aria-selected={activeTab === 'edit-profile'}
                                            role="tab"
                                        >
                                            Edit Profile
                                        </button>

                                        <button
                                            type="button"
                                            className={`font-semibold py-2 px-2 inline-flex items-center gap-x-2 border-b-[3px] border-transparent whitespace-nowrap hover:text-primary hover:border-primary focus:outline-none focus:text-primary ${activeTab === 'preferences' ? 'tab_active' : ''}`}
                                            onClick={() => setActiveTab('preferences')}
                                            aria-selected={activeTab === 'preferences'}
                                            role="tab"
                                        >
                                            Preferences
                                        </button>

                                        <button
                                            type="button"
                                            className={`font-semibold py-2 px-2 inline-flex items-center gap-x-2 border-b-[3px] border-transparent whitespace-nowrap hover:text-primary hover:border-primary focus:outline-none focus:text-primary ${activeTab === 'security' ? 'tab_active' : ''}`}
                                            onClick={() => setActiveTab('security')}
                                            aria-selected={activeTab === 'security'}
                                            role="tab"
                                        >
                                            Security
                                        </button>
                                    </nav>
                                </div>

                                {/* x---------------------------------x Tab Content x---------------------------------x */}
                                <div className="mt-3">
                                    {activeTab === 'edit-profile' && (
                                        <div id="tabs-edit-profile" role="tabpanel">
                                            {/* x---------------------------------x EditProfile Tab Section x---------------------------------x */}
                                            <EditProfileTab />
                                        </div>
                                    )}
                                    {activeTab === 'preferences' && (
                                        <div id="tabs-preferences" role="tabpanel">
                                            {/* x---------------------------------x Preferences Tab Section x---------------------------------x */}
                                            <PreferencesTab />
                                        </div>
                                    )}
                                    {activeTab === 'security' && (
                                        <div id="tabs-security" role="tabpanel">
                                            {/* x---------------------------------x Security Tab Section x---------------------------------x */}
                                            <SecurityTab />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Setting